import type { TopArticle } from '../analyticsApi';

// A table, not a chart: more than a handful of rows that all carry meaning.
// tabular-nums belongs here — columns of numbers that must align vertically.
export default function TopArticlesTable({ articles }: { articles: TopArticle[] }) {
  return (
    <section className="rounded-2xl bg-white p-5 shadow-card">
      <h3 className="font-nunito text-sm text-ink-soft">Most read blogs</h3>

      {articles.length === 0 ? (
        <p className="mt-6 font-nunito text-sm text-meta">No data yet</p>
      ) : (
        <table className="mt-4 w-full font-nunito text-sm">
          <thead>
            <tr className="border-b border-hairline text-left text-xs text-meta">
              <th className="pb-2 font-normal">Blog</th>
              <th className="pb-2 text-right font-normal">Views</th>
            </tr>
          </thead>
          <tbody>
            {articles.map((article) => (
              <tr key={article.slug} className="border-b border-hairline last:border-0">
                <td className="py-2 text-ink">{article.slug}</td>
                <td className="py-2 text-right text-ink [font-variant-numeric:tabular-nums]">
                  {article.pageviews}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </section>
  );
}
